import { useEffect, useRef, useState } from 'react';
import { HubConnectionBuilder } from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import { useDispatch } from 'react-redux';

const useSignalR = (hubUrl) => {
    const [connection, setConnection] = useState(null);
    const isConnected = useRef(false);
    const dispatch = useDispatch();
    const currentSession = window.sessionStorage.getItem('session_id');

    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${hubUrl}/hubs/grid`)
            .configureLogging(signalR.LogLevel.Information)
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);

        const startConnection = async (currentSession) => {
            try {
                await newConnection.start();
                console.info("Signal R connection started");
                isConnected.current = true;

                newConnection.on("BroadcastMessage", (message) => {
                    const { type, data } = message;
                    switch (type) {
                        case 'gridUpdate':
                            if (data.sessionId !== currentSession) {
                            dispatch({ type: 'DATAGRID_VALUE_CHANGED', payload: data });
                            }
                            break;
                        case 'Export':
                            dispatch({ type: 'DATAGRID_EXPORT_COMPLETED', payload: data });
                            break;
                        default:
                            console.warn(`Unhandled message type: ${type}`);
                    }
                }
                );

                newConnection.on('SendGroupMessage', async message => {
                    const { type, data } = message;
                    switch (type) {
                        case 'gridUpdate':
                            if (data.sessionId !== currentSession) {
                            dispatch({ type: 'DATAGRID_VALUE_CHANGED', payload: data });
                            }
                            break;
                        case 'Export':
                            dispatch({ type: 'DATAGRID_EXPORT_COMPLETED', payload: data });
                            break;
                        default:
                            console.warn(`Unhandled message type: ${type}`);
                    }
                });
            } catch (error) {
                console.error('Error starting connection or joining group:', error);
            }
        };

        startConnection(currentSession);

        return () => {
            if (newConnection) {
                newConnection.stop();
            }
        };
    }, [hubUrl, dispatch, currentSession]);

    return isConnected.current;
};

export default useSignalR;
